import React from 'react';
import './ImageStyleSheet.css';

function BU2() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/bu3.jpg" className='img-view'/>
        </div>
    )
}

export default BU2
